import styled from "styled-components";
import {RouterOutletDefaultBox} from "./router-outlet.default.box";
import {baseColors} from "../../../themes/definitions/harrahs/base-colors";

export const RouterOutletWsopBox = styled(RouterOutletDefaultBox)`

  background: radial-gradient(ellipse at center, ${baseColors.gray033} 0%, ${baseColors.black} 100%);
`